import { __awaiter } from "tslib";
import { ConfigurationChangeEvent } from "@plansoft-configuration-renderer/events";
import { handleConfigurationEvent } from "../events/handleConfigurationEvent";
import { decrementOpenRequests, incrementOpenRequests, } from "../reducers/actions";
import { getSelectors, getSessionId } from "../reducers/selectors";
import { handleCfgStateResponse } from "./handleCfgStateResponse";
export function resetAttributes(attributeResets) {
    return (dispatch_1, getState_1, _a) => __awaiter(this, [dispatch_1, getState_1, _a], void 0, function* (dispatch, getState, { cfgApi }) {
        try {
            dispatch(incrementOpenRequests());
            const rootState = getState();
            const sessionid = getSessionId(rootState);
            const selectors = getSelectors(rootState);
            // TODO do we need to reset the local state before?
            // call api
            const response = yield cfgApi.resetConfigurationAttributes({
                id: sessionid,
                resetConfigurationAttributesParams: {
                    selectors,
                    attributes: attributeResets.map((reset) => reset.attributePath),
                },
            });
            // set response
            dispatch(handleCfgStateResponse(response));
            dispatch(handleConfigurationEvent(new ConfigurationChangeEvent(response.id)));
        }
        finally {
            dispatch(decrementOpenRequests());
        }
    });
}
//# sourceMappingURL=resetAttributes.js.map